__turbopack_context__.v({
  "container": "M-8cPq_container",
  "productItem": "M-8cPq_productItem",
  "productListWrapper": "M-8cPq_productListWrapper",
  "title": "M-8cPq_title",
});
